module.exports = __webpack_public_path__ + "img/empty.92989e62.png";